import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardProtocolsEdit = guard(groupRights.Protocols)('edit')
export const guardProtocolsWatch = guard(groupRights.Protocols)('watch')
export const guardProtocolsCreate = guard(groupRights.Protocols)('create')

